// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

import App from './App'
import * as firebase from 'firebase'
import router from './router'

Vue.use(Vuetify)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyBJ3nT8uI_T_jbwxB2uQFj_BCuiRXUjhro',
      authDomain: 'digitaltranquility-e86a1.firebaseapp.com',
      databaseURL: 'https://digitaltranquility-e86a1.firebaseio.com',
      projectId: 'digitaltranquility-e86a1',
      storageBucket: 'digitaltranquility-e86a1.appspot.com'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js